import React from 'react';

import cs from 'classnames';
import styled from 'styled-components';

import {BootstrapMinMediumMediaQuery} from 'app/general/mediaqueries';

type Props = {
  className?: string;
  children: JSX.Element;
  height: string;
};

export const StickySidebar = ({children, className, height}: Props) => (
  <BootstrapMinMediumMediaQuery>
    <CustomHeightDiv height={height} className={cs('sticky-top', className)}>
      {children}
    </CustomHeightDiv>
  </BootstrapMinMediumMediaQuery>
);

const CustomHeightDiv = styled.div<{height: string}>`
  height: ${({height}) => height};
  z-index: 0;
`;
